import { SongsService } from './../../api/services/songs-service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {Component, OnInit, Input, Output, EventEmitter,SimpleChange} from '@angular/core';
import {AuthService, PlaylistService} from '../../api/';
import {AlbumsService} from '../../api';
import {MdDialog, MdDialogRef} from '@angular/material';
import {EditPlaylistComponent} from '../../playlists/edit-playlist/edit-playlist.component';
import {SongDetailComponent} from '../';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {PlayerService} from '../../player/services/player.service';
import * as _ from 'lodash';

@Component({
  selector: 'albumview-songs',
  templateUrl: './albumview-songs.component.html',
  styleUrls: ['./albumview-songs.component.css']
})
export class AlbumviewSongsComponent implements OnInit {
  @Input() items: any;
  @Input() itemFromArtist: boolean = false;
  public creditsArray: any = [];
  @Input() playlists: any;
  private type: string = '';
  @Input() laricSize: number;
  public slideIndex = 0;
  @Output() refreshList: EventEmitter<any> = new EventEmitter();
  @Output() refreshList2: EventEmitter<any> = new EventEmitter();
  dialogRef: MdDialogRef<EditPlaylistComponent>;
  @Output() refreshPlaylist: EventEmitter<any> = new EventEmitter();
  @Output() itemRemoved: EventEmitter<any> = new EventEmitter();
  @Output() playListDeleted: EventEmitter<any> = new EventEmitter();
  dialogRef2: MdDialogRef<SongDetailComponent>;
  checkIfMobile: boolean = false;
  item:any;
  index:number = 0;
  playingId: number = 0;
  private readMore: boolean = false;
  private readMore2: boolean = false;
  // for popup
  @BlockUI() blockUI: NgBlockUI;
  song:any = [];
  public writersArray: any = [];
  // to disable the button for Radio Playlist
  disableButtonForRadio:boolean = false;

  constructor(public playerService: PlayerService,private router: Router,private route: ActivatedRoute, private authService: AuthService, public dialog: MdDialog, private albumService: AlbumsService, private songService: SongsService, private playlsitService: PlaylistService) {
  }

  ngOnInit() {
    // to check if created by exists
    if(this.items.created_by) {
      for(let i = 0; i < this.items.length; i++){
        var res = this.items[i].created_by.split("|");
        this.items[i].created_by = res[0];
      }
    }
    if (screen.width <= 668) {
      this.checkIfMobile = true;
    }
    // check the count to disable the action buttons for radio
    let songsCount: number = parseInt(localStorage.getItem("listenCount"));
    if (songsCount >= 5) {
      this.disableButtonForRadio = true;
    } else {
      this.disableButtonForRadio = false;
    }
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.items = changes['items'].currentValue;
    this.playerService.playerEvent.subscribe((event) => {
      if (event.type === 'track:id') {
        this.playingId = this.playerService.playingId;
        let index = _.findIndex(this.items, {
          id: this.playingId
        });
        if(index != -1){
          this.index = index;
          let tempItem = this.items[index];
          this.getPlaylistOrSongData(tempItem);
        }
      }
    });
    if(this.items.length > 0) {
      this.playingId = this.playerService.playingId;
      let index = _.findIndex(this.items, {
        id: this.playingId
      });
      if(index != -1) {
        this.index = index;
        let tempItem = this.items[index];
        this.getPlaylistOrSongData(tempItem);
      } else {
        if(this.items[this.index]) {
          let tempItem = this.items[this.index];
          this.getPlaylistOrSongData(tempItem);
        } else {
          this.index = 0;
          let tempItem = this.items[this.index];
          this.getPlaylistOrSongData(tempItem);
        }
      }
    }
    if (this.route.snapshot.data['type']) {
      this.type = this.route.snapshot.data['type'];
    }
  }

  // to get the song or playlist data based on the slug
  getPlaylistOrSongData(item: any) {
    this.blockUI.start('Loading, please wait...');
    if(item._type == 'playlist') {
      this.item = item;
      this.blockUI.stop();
    } else if(item._type == 'song') {
      if(!item.credits) {
        this.songService.getSongDetailBySlug(item.slug).subscribe(res => {
          this.item = res;
          if (this.item.lyrics != null) {
            this.item.songLyrics = this.item.lyrics;
            this.item.songLyrics2 = this.item.songLyrics.slice(0, this.laricSize);
          }
          this.removeSlash(this.item);
          this.removeDuplicatCredits(this.item);
          this.items[this.index] = this.item;
          this.blockUI.stop();
        });
      } else {
        this.item = this.items[this.index];
        if (this.item.lyrics != null) {
          this.item.songLyrics = this.item.lyrics;
          this.item.songLyrics2 = this.item.songLyrics.slice(0, this.laricSize);
        }
        this.blockUI.stop();
      }
    }
  }

  plusDivs(n) {
    // if((this.items.length - this.index) < 2) {
    //   this.refreshList.emit();
    // }
    if(this.items[this.index + n]){
      this.index = this.index + n;
      let tempItem = this.items[this.index];
      this.getPlaylistOrSongData(tempItem);
    } else {
      let tempItem = this.items[this.index];
      this.getPlaylistOrSongData(tempItem);
    }
    this.playerService.isSongInQueue.next(this.item);
    let ele = document.getElementById('songId');
    ele.classList.add("fadeOut");
    setTimeout(
      function Remove() {
        ele.classList.remove("fadeOut");
      },
    300 );
  }

  toggleReadMore() {
    this.readMore = !this.readMore;
  }

  toggleReadMore2() {
    this.readMore2 = !this.readMore2;
  }

  editPlaylist(event,item) {
    event.stopPropagation();
    event.preventDefault();
    this.dialogRef = this.dialog.open(EditPlaylistComponent, {
      disableClose: false,
      width: '800px'
    });
    this.dialogRef.componentInstance.playlist = item;
    this.dialogRef.afterClosed().subscribe(result => {
      this.refreshPlaylist.emit({refresh: 1});
      this.dialogRef = null;
    });
  }

  RedirectToSongsSearch(type,name,islocation,iswriter,ispublisher,islabel) {
    if(islabel){
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'namee': name,
          'islabel': islabel
        },
      };
      this.router.navigate(['/songssearchoncredits'], navigationExtras);
    } else if(iswriter){
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'namee': name,
          'iswriter': iswriter
        },
      };
      this.router.navigate(['/songssearchoncredits'], navigationExtras);
    } else if(ispublisher){
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'namee': name,
          'ispublisher': ispublisher
        },
      };
      this.router.navigate(['/songssearchoncredits'], navigationExtras);
    } else {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'namee': name,
          'type': type,
          'islocation': islocation
        },
      };
      this.router.navigate(['/songssearchoncredits'], navigationExtras);
    }
    if(this.type  == "CS") {
      this.refreshList2.emit();
    }
    if(this.dialogRef2){
      this.dialogRef2.close();
    }
  }

  emit(event) {
    this.playListDeleted.emit(event);
  }

  // to open the poup when clicked on the song name
  openSongDetail(event) {
    this.blockUI.start('Loading, please wait...');
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    setTimeout(()=> {
      this.dialogRef2 = this.dialog.open(SongDetailComponent, {
        width: width,
      });
      this.dialogRef2.componentInstance.slug = this.item.slug;
      return false;
    }, 2000)
  }

  removeSlash(song) {
    if(song) {
      if (typeof song.credits === "object" && song.credits != null) {
        for (var j = 0; j < song.credits.length; j++) {
          song.credits[j].credit_type = song.credits[j].credit_type.replace("_", " ");
          song.credits[j].credit_type = song.credits[j].credit_type.charAt(0).toUpperCase() + song.credits[j].credit_type.slice(1);
        }
      }
    }
    return song;
  }

  removeDuplicatCredits(song){
    if(song) {
      this.writersArray.length = 0 ;
      for(var g = 0; g < 4; g++ ) {
        song.writers.forEach((item, index) => {
          if (index !== song.writers.findIndex(i => i.writer === item.writer)) {
            this.writersArray.push(song.writers[index]);
            song.writers.splice(index, 1);
          }
        });
      }
      this.creditsArray.length = 0 ;
      for(var f = 0; f < 4; f++ ) {
        song.credits.forEach((item, index) => {
          if (index !== song.credits.findIndex(i => i.credit_type === item.credit_type)) {
            this.creditsArray.push(song.credits[index]);
            song.credits.splice(index, 1);
          }
        });
      }
      if(this.creditsArray && this.creditsArray.length) {
        for(var j =0 ; j < this.creditsArray.length ; j++) {
          for(var k = 0; k < song.credits.length ; k++){
            if(song.credits[k].credit_type == this.creditsArray[j].credit_type){
              if(!(song.credits[k].name.includes(this.creditsArray[j].name))){
                if(!song.credits[k].values){
                  song.credits[k]["values"] = [];
                }
                if(!(song.credits[k].values.includes(song.credits[k].name))){
                  song.credits[k].values.push(song.credits[k].name);
                }
                if(!(song.credits[k].values.includes(this.creditsArray[j].name))){
                  song.credits[k].values.push(this.creditsArray[j].name);
                }
              }
            }
          }
        }
      }
      for(var k = 0; k < song.credits.length ; k++) {
        if(!song.credits[k].values){
          song.credits[k]["values"] = [];
        }
        if(!(song.credits[k].values.includes(song.credits[k].name))) {
          var locationPartt = song.credits[k].name.split(",");
          for (var p = 0; p < locationPartt.length; p++) {
            locationPartt[p].replace(",", "");
            song.credits[k].values.push(locationPartt[p]);
          }
        }
        if(song.credits[k].location && song.credits[k].location != null) {
          song.credits[k]["locations"] = [];
          var locationParts = song.credits[k].location.split(",");
          for(var m = 0; m < locationParts.length; m++ ){
            if(!(locationParts[m].includes("."))){
              song.credits[k].locations.push(locationParts[m]);
            }
            else{
              var locationParts2 = locationParts[m].split(".");
              for(var n = 0; n < locationParts2.length; n++ ){
                song.credits[k].locations.push(locationParts2[n]);
              }
            }
          }
        }
      }
      //publisher array making
      if(!song.publishers) {
        song["publisherss"] = [];
        if (song.publisher) {
          var locationParttt = song.publisher.split(",");
          for (var p = 0; p < locationParttt.length; p++) {
            locationParttt[p].replace(",", "");
            song.publisherss.push(locationParttt[p]);
          }
        }
      } else {
        song["publisherss"] = [];
        for (let m = 0; m < song.publishers.length; m++) {
          if (song.publishers[m].publisher) {
            song.publisherss.push(song.publishers[m].publisher);
          }
        }
      }
    }
    return song;
  }

}



// WEBPACK FOOTER //
// ./src/app/songs/albumview-songs/albumview-songs.component.ts